import React from "react";
import DepartureSection from "../PlantMaterialControl/DepartureSection";
import {FIXED_ARRIVAL_SECTION} from "../../../Model/Model";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @description
 * Renders the information fields of a crates and pallets return form: the
 * arrival of the vehicle, which is always enabled because the movement is
 * fixed and the user cannot select its direction.
 *
 * @param {Function} t - Translation function.
 * @param {Object} materialRequest - Current form information.
 * @param {Function} handleChange - Change handler of the form.
 * @param {boolean} emptyFields - Indicates whether the required fields must be highlighted.
 */
const CratesAndPalletsReturnInformationFields = ({
    t,
    materialRequest,
    handleChange,
    emptyFields
}) => {

    return (
        <div className={"col-12 mb-3"}>
            <DepartureSection
                t={t}
                section={FIXED_ARRIVAL_SECTION}
                materialRequest={materialRequest}
                handleChange={handleChange}
                emptyFields={emptyFields}
            />
        </div>
    );
};

export default CratesAndPalletsReturnInformationFields;
